var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3698_10742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 6.00033H7.33464L7.33464 4.66699H8.66797V6.00033ZM8.66797 11.3337L7.33464 11.3337L7.33464 7.33366L8.66797 7.33366L8.66797 11.3337ZM8.00797 14.667C11.688 14.667 14.668 11.6803 14.668 8.00033C14.668 4.32032 11.688 1.33366 8.00797 1.33366C4.3213 1.33366 1.33463 4.32032 1.33463 8.00033C1.33463 11.6803 4.3213 14.667 8.00797 14.667ZM8.0013 2.66699C10.948 2.66699 13.3346 5.05366 13.3346 8.00033C13.3346 10.947 10.948 13.3337 8.0013 13.3337C5.05464 13.3337 2.66797 10.947 2.66797 8.00033C2.66797 5.05366 5.05464 2.66699 8.0013 2.66699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3698_10742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 -1 16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.dce966e9548b50acfd82bfbc96ca4a12.svg";
export { ForwardRef as ReactComponent };